import { useEffect, useState } from "react";
import { useWindowDimensions } from "react-native";
import Animated, {
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated";

import {
  AnimationDurations,
  AnimationEasings,
} from "@whoosh/design-system/src/theme/animations";
import { theme } from "@whoosh/design-system/src/theme/restyle/theme";

export type NavigationMenuPanelProps = {
  isClosing: boolean;
  panelWidth: number;
  children: React.ReactNode;
};

export const NavigationMenuPanel = ({
  isClosing,
  panelWidth,
  children,
}: NavigationMenuPanelProps) => {
  const { width: panelScreenWidth } = useWindowDimensions();
  const isMobile = panelScreenWidth < theme.breakpoints.md;
  const [internalIsClosing, setInternalIsClosing] = useState(true);

  const slideOffset = panelWidth + (isMobile ? 0 : 16);

  useEffect(() => {
    setInternalIsClosing(isClosing);
  }, [isClosing]);

  const animatedStyle = useAnimatedStyle(
    () => ({
      transform: [
        {
          translateX: withTiming(internalIsClosing ? -slideOffset : 0, {
            duration: AnimationDurations.moderate02,
            easing: internalIsClosing
              ? AnimationEasings.exit
              : AnimationEasings.entrance,
          }),
        },
      ],
    }),
    [internalIsClosing, slideOffset]
  );

  return (
    <Animated.View
      style={[
        {
          position: "absolute",
          top: isMobile ? 0 : 16,
          left: isMobile ? 0 : 16,
          bottom: isMobile ? 0 : 16,
          width: panelWidth,
          backgroundColor: "white",
          borderRadius: isMobile ? 0 : 24,
          overflow: "hidden",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 24 },
          shadowOpacity: 0.12,
          shadowRadius: 64,
          elevation: 8,
        },
        animatedStyle,
      ]}
    >
      {children}
    </Animated.View>
  );
};
